/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var processInclude = __webpack_require__(3);

	$(document).ready(function () {
	    processInclude(__webpack_require__(192));
	});

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	'use strict';

	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

	module.exports = function (include) {
	    if (typeof include === 'function') {
	        include();
	    } else if ((typeof include === 'undefined' ? 'undefined' : _typeof(include)) === 'object') {
	        Object.keys(include).forEach(function (key) {
	            if (typeof include[key] === 'function') {
	                include[key]();
	            }
	        });
	    }
	};

/***/ }),

/***/ 93:
/***/ (function(module, exports) {

	'use strict';

	/**
	 * create the opening hours template, based on the information available
	 * @param {Array} openingHours - an array (usually with a length of 7), which rapresent the days of the week
	 *
	 * @return {html} the template populated with opening hours data
	 */

	function buildCollectionPointHoursTemplate(openingHours) {
	    var $hoursTemplate = $('#clickCollectHoursTemplate').children().clone(),
	        $daytemplate,
	        dayOfWeek,
	        result = $(document.createElement("p"));

	    for (var i = 0; i < openingHours.length; i++) {
	        dayOfWeek = openingHours[i];
	        $daytemplate = $hoursTemplate.clone();
	        $daytemplate.find('.js-day').html(dayOfWeek.day + ':');
	        // Combine all hours into a single string, separated by commas
	        var combinedHours = dayOfWeek.hours.join(', ');
	        $daytemplate.find('.js-hour').html(combinedHours);

	        // Append the modified day template to the result
	        $daytemplate.appendTo(result);
	    }
	    return result;
	}

	/**
	 * Set store address
	 * @param {template} template Template
	 * @param {Object} store Store data object
	 * @param {Object} $address1 Store address1
	 * @param {Object} $address2 Store address2
	 */
	function fillStoreAddress(template, store, $address1, $address2) {
	    // For Bata IT, MY: Store address is splitted in two lines
	    if ($address2.length) {
	        if (store.a2) {
	            // store has address 2
	            $address1.html(store.a1 + '<br>');
	            $address2.html(store.a2 + '<br>');
	        } else {
	            $address1.html(store.a1 + '<br>');
	            $address2.html('');
	        }
	        // For the other sites: Both addresses (if address2 exists) are displayed in one line
	    } else {
	        $address1.html(store.a2 ? store.a1 + ' ' + store.a2 + '<br>' : store.a1 + '<br>');
	    }
	}

	/**
	 * Show COD allowed/disallowed message on each store's frontend
	 * @param {template} template Template
	 * @param {Object} store Store data object
	 */
	function showPickupPointCODAllowed(store, template) {
	    var codNotAvailableMsg = store.codAllowed === false ? $('#storeListResults').attr('data-cod-not-allowed-message') : "";
	    template.content.querySelector('.js-store-details-number').setAttribute('data-cod-allowed', store.codAllowed);
	    template.content.querySelector('.js-cod-allowed').textContent = codNotAvailableMsg;

	    var codAllowedString = store.codAllowed ? 'true' : 'false';
	    template.content.querySelector('.js-goto-store').setAttribute('data-codallowed', codAllowedString);
	}

	/**
	 * create the StoreLocator Tiles for Stores List view
	 * @param {Object} store - a store object
	 * @param {Element} template - the template to populate with stores's data
	 * @param {Boolean} isClickAndCollect - true if it is the pin for clickAndCollect template
	 * @param {Boolean} isFilterByStoreBrands - true if filtered by brand
	 * @param {String} controllerURL - the controller to call if the user clicks on the pin
	 * @param {Boolean} hideStoreDetailsButton - true if it is needed to hide the button to reach the store details
	 * @return {String} the template populated with stores's data
	 */
	// eslint-disable-next-line complexity
	function buildStoreMarkerPin(store, template, isClickAndCollect, isFilterByStoreBrands, controllerURL, hideStoreDetailsButton) {
	    var storeID = store.ID,
	        storeDetailUrl = controllerURL ? controllerURL + '?storeID=' + store.ID + '&distance=' + store.dist + '&distanceUnit=' + store.dUnit : '',
	        storePhone = store.phone,
	        type,
	        typeDV,
	        brand,
	        brandDV;

	    // set
	    var $storeInfo = template.find('.js-storeId');
	    $storeInfo.data('store-id', storeID);

	    if (store.brand === 'f') {
	        brand = 'flagship';
	        brandDV = 'Flagship store';
	    } else {
	        brand = store.brand;
	        brandDV = store.brandDV;
	    }
	    $storeInfo.data('storebrand', brand);

	    if (store.type === 'o') {
	        type = 'original';
	        typeDV = 'Original store';
	    } else {
	        type = store.type;
	        typeDV = store.typeDV;
	    }
	    $storeInfo.attr('type', type);

	    var $storeNameSection = template.find('.js-storeName'),
	        $phoneContainer = template.find('.js-phoneContainer'),
	        $phone = $phoneContainer.find('.js-storePhone'),
	        $storePCode = template.find('.js-postalCode'),

	    // zipCodePublic is only for pickup points in CZ, it has to be setted in the shipping address, but it has not to be displayed
	    zipCodeForShipping = store.pCodePublic,
	        openingHours = store.hours,
	        $address1 = template.find('.js-storeAddress'),
	        $address2 = template.find('.js-storeAddress2');
	    $storeNameSection.attr('href', storeDetailUrl);
	    $storeNameSection.html(store.name);
	    var distance = store.dist && store.dist !== 'null' ? store.dist + ' ' + store.dUnit : '';
	    template.find('.js-storeDistance').html(distance);

	    fillStoreAddress(template, store, $address1, $address2);

	    template.find('.js-storeCity').html(store.city ? store.city + ',' : '');
	    template.find('.js-storeStateCode').html(store.sCode ? store.sCode + ',' : '');
	    template.find('.js-storeDistrict').html(store.district ? store.district + ',' : '');
	    template.find('.js-storeSubdistrict').html(store.subdistrict ? store.subdistrict + ',' : '');
	    $storePCode.html(store.pCode);
	    $storePCode.attr('data-public-postal-code', zipCodeForShipping || '');
	    if ($phone.length > 0) {
	        if (storePhone && storePhone.trim() !== '') {
	            $phoneContainer.removeClass('d-none');
	            $phone.html(storePhone);
	            $phone.attr('href', 'tel:' + storePhone);
	        } else {
	            // if a store doesn't have a phone, also the phone icon will be hidden
	            $phoneContainer.addClass('d-none');
	        }
	    }
	    // for Click & Collect the hours is a string field in the DB, for Pickup Points is an array of days
	    if (typeof openingHours === 'string' || !openingHours) {
	        template.find('.js-storeHours').html(unescape(openingHours || ''));
	    } else {
	        var hoursTemplate = buildCollectionPointHoursTemplate(openingHours);
	        template.find('.js-storeHours').html(hoursTemplate);
	    }
	    if (!store.hours) {
	        template.find('.cc-icon-hours').addClass('d-none');
	    } else {
	        template.find('.cc-icon-hours').removeClass('d-none');
	    }
	    if (hideStoreDetailsButton) {
	        template.find('.storeDetails').addClass('d-none');
	    }
	    if (isClickAndCollect) {
	        template.find('.js-storeDetails').removeAttr('href');
	        var tileTemplateID = $('#queryStoreParam').data('template-tile');
	        var url = document.querySelector('#' + tileTemplateID).content.querySelector('.js-select-clickcollect-store').getAttribute('data-url');
	        var $storeInfoButton = template.find('.storeInfoButton');
	        $storeInfoButton.addClass('js-select-clickcollect-store');
	        $storeInfoButton.attr('data-url', url);
	        $storeInfoButton.attr('data-storeid', storeID);
	        $storeInfoButton.attr('data-title', store.name);
	        template.find('.js-storelocator-message').remove();
	    } else {
	        if (isFilterByStoreBrands === true) {
	            template.find('.js-storeTypeDisplayValue').html(brandDV);
	        } else {
	            template.find('.js-storeTypeDisplayValue').html(typeDV);
	        }
	        template.find('.js-storeDetails').attr('href', storeDetailUrl);

	        // Remove the click & collect exclusive element since they are not meant to be in the storelocator
	        template.find('.js-clickAndCollect-message').remove();
	    }
	    var storePinHtml = template.clone();
	    var storePin = {
	        name: store.name,
	        latitude: store.lat,
	        longitude: store.long,
	        type: type,
	        storeBrand: brand,
	        infoWindowHtml: storePinHtml.html()
	    };
	    return storePin;
	}

	/**
	 * create the StoreLocator Pin for Store
	 * @param {Object} store - a store object
	 * @param {Element} template - the template to populate with stores's data
	 * @return {String} the template populated with stores's data
	 */
	function buildStoreCard(store, template, isFilterByStoreBrands, controllerURL) {
	    var storePhone = store.phone,
	        storeDetailUrl = controllerURL + '?storeID=' + store.ID + '&distance=' + store.dist + '&distanceUnit=' + store.dUnit,
	        storeID = store.ID,
	        type,
	        typeDV,
	        brand,
	        brandDV;
	    // set
	    template.find('.js-store-details-number').attr('object', JSON.stringify(store));
	    template.find('.js-storeContainer').attr('id', storeID);
	    var $phone = template.find('.js-storePhone'),
	        $storePCode = template.find('.js-postalCode'),

	    // pCodePublic is only for pickup points in CZ, it has to be setted in the shipping address, but it has not to be displayed
	    zipCodeForShipping = store.pCodePublic;
	    template.find('.js-storeId').data('store-id', storeID);

	    if (store.brand === 'f') {
	        brand = 'flagship';
	        brandDV = 'Flagship store';
	    } else {
	        brand = store.brand;
	        brandDV = store.brandDV;
	    }
	    template.find('.js-storeId').attr('storebrand', brand);

	    if (store.type === 'o') {
	        type = 'original';
	        typeDV = 'Original store';
	    } else {
	        type = store.type;
	        typeDV = store.typeDV;
	    }
	    template.find('.js-storeId').attr('type', type);
	    var $storeNameSection = template.find('.js-storeName');
	    $storeNameSection.attr('href', storeDetailUrl);
	    $storeNameSection.html(store.name);
	    if (isFilterByStoreBrands === true) {
	        template.find('.js-storeTypeDisplayValue').html(brandDV);
	    } else {
	        template.find('.js-storeTypeDisplayValue').html(typeDV);
	    }
	    if (store.dist && store.dist !== 'null') {
	        template.find('.js-storeDistance').html(store.dist + ' ' + store.dUnit);
	    }

	    var $address1 = template.find('.js-storeAddress');
	    var $address2 = template.find('.js-storeAddress2');
	    fillStoreAddress(template, store, $address1, $address2);

	    template.find('.js-storeCity').html(store.city ? store.city + ',' : '');
	    template.find('.js-storeStateCode').html(store.sCode ? store.sCode + ',' : '');
	    template.find('.js-storeDistrict').html(store.district ? store.district + ',' : '');
	    template.find('.js-storeSubdistrict').html(store.subdistrict ? store.subdistrict + ',' : '');
	    $storePCode.html(store.pCode);
	    $storePCode.attr('data-public-postal-code', zipCodeForShipping || '');
	    if (storePhone && storePhone.length > 0) {
	        $phone.html(storePhone);
	        $phone.attr('href', 'tel:' + storePhone);
	        $phone.removeClass('d-none');
	    } else {
	        $phone.addClass('d-none');
	    }
	    template.find('.js-storeHours').html(unescape(store.hours ? store.hours : ''));
	    var storeTemplate = template.clone();

	    return storeTemplate[0].outerHTML;
	}

	/**
	 * Create pin and stores tile from Stores-Find response data
	 * @param {Object} data - the response from Stores-FindStores
	 * @return {Object} pins and store list templates
	 */
	function showStoresResults(data, isFilterByStoreBrands) {
	    var stores = data.stores,
	        pins = [],
	        storeList = '',
	        markerTemplate = $($('#storeMarkerTemplate')[0].content.children[0]),
	        listTemplate = $($('#storeTileTemplate')[0].content.children[0]),
	        controllerURL = data.controllerURL;
	    stores.forEach(function (store) {
	        pins.push(buildStoreMarkerPin(store, markerTemplate, false, isFilterByStoreBrands, controllerURL));
	        storeList += buildStoreCard(store, listTemplate, isFilterByStoreBrands, controllerURL);
	    });
	    return {
	        pins: pins,
	        storeList: storeList
	    };
	}

	/**
	 * Create a store tile from a collection point when the "select" button in checkout is selected
	 * @param {Object} pickupPoint - the collection point object
	 * @param {template} template -the template which will populated using the pickup point data
	 */
	function buildPickupPointCard(pickupPoint, template) {
	    var $storePCode = template.find('.js-postalCode'),
	        $city = template.find('.js-storeCity'),
	        $distanceContainer = template.find('.js-storeDistanceContainer'),
	        $storeNameSection = template.find('.js-storeName'),
	        $storeAddress = template.find('.js-storeAddress'),
	        $storeAddress2 = template.find('.js-storeAddress2'),

	    // Only some collections points have stateCode (InPost for IT)
	    $stateCode = template.find('.js-storeStateCode'),

	    // zipCodePublic is only for pickup points in CZ, it has to be setted in the shipping address, but it has not to be displayed
	    zipCodeForShipping = pickupPoint.pCodePublic,
	        openingHours = pickupPoint.hours;

	    $storeNameSection.html(pickupPoint.name);
	    if (pickupPoint.dist && pickupPoint.dist !== 'null') {
	        $distanceContainer.removeClass('d-none');
	        $distanceContainer.find('.js-storeDistance').html(pickupPoint.dist + ' ' + pickupPoint.dUnit);
	    } else {
	        $distanceContainer.addClass('d-none');
	    }
	    // only some pickup points have the id, check useParcelShopCode attribute inside the shipping method
	    template.attr('data-store-id', pickupPoint.ID);
	    template.attr('data-companyname', pickupPoint.name);
	    template.attr('data-cod-allowed', pickupPoint.codAllowed);

	    // Grabbing the codAllowed value of the closest "store" selected and setting it in the selected Card.
	    var codAllowed = template.attr('data-cod-allowed');
	    $('#selectedStore').attr('data-cod-allowed', codAllowed);
	    // Value that passes the codAllowed into the backend
	    $('.js-selected-store-container').attr('data-cod-allowed', codAllowed);

	    // Address2 is not present in pickup points
	    // It is added for future implementation
	    fillStoreAddress(template, pickupPoint, $storeAddress, $storeAddress2);

	    $city.html(pickupPoint.city ? pickupPoint.city + ',' : '');
	    $city.attr('data-city', pickupPoint.city);
	    $storePCode.html(pickupPoint.pCode);
	    $storePCode.attr('data-public-postal-code', zipCodeForShipping || '');
	    if ($stateCode.length) {
	        $stateCode.html(pickupPoint.sCode || '');
	    }
	    if (typeof openingHours === 'string' || !openingHours) {
	        template.find('.js-storeHours').html(unescape(openingHours || ''));
	    } else {
	        var hoursTemplate = buildCollectionPointHoursTemplate(openingHours, template.find('.js-storeHours'));
	        template.find('.js-storeHours').html(hoursTemplate);
	    }
	    var pickupPointTemplate = template.clone();
	    var result = pickupPointTemplate[0].outerHTML;

	    return result;
	}

	module.exports = {
	    buildCollectionPointHoursTemplate: buildCollectionPointHoursTemplate,
	    buildPickupPointCard: buildPickupPointCard,
	    showPickupPointCODAllowed: showPickupPointCODAllowed,
	    buildStoreMarkerPin: buildStoreMarkerPin,
	    showStoresResults: showStoresResults,
	    fillStoreAddress: fillStoreAddress
	};

/***/ }),

/***/ 94:
/***/ (function(module, exports) {

	'use strict';

	// This file is used in storelocator, find in store, click & collect (+ collection point) page in order to manage the user position, wich is used to calculate the distances

	var userPositionData = {
	    userGeolocation: null,
	    userAddress: null
	};

	var lastAvailableGeolocationKey = 'lastAvailableGeolocation';

	function getUserPositionIfAvailable(callback) {
	    var coords = {
	        lat: null,
	        lng: null,
	        isDefaultCenterLocation: false
	    };
	    var success = function success(position) {
	        coords.lat = position.coords.latitude;
	        coords.lng = position.coords.longitude;
	        callback(coords);
	    };
	    if (navigator.permissions) {
	        navigator.permissions.query({ name: 'geolocation' }).then(function (result) {
	            if (result.state === 'granted') {
	                navigator.geolocation.getCurrentPosition(success);
	            }
	        });
	    } else {
	        callback(JSON.parse(localStorage.getItem(lastAvailableGeolocationKey)));
	    }
	}

	/**
	 * @description set the user's position, based on the type of it
	 * @param {string} lat - the latitude to set
	 * @param {string} long - the longitude to set
	 * @param {string} type - 'userAddress' to set the user's Address, 'userGeolocation' to set user's geolocation position
	 */
	function setUserPosition(lat, long, type) {
	    if (lat && long) {
	        userPositionData[type] = {
	            lat: lat,
	            long: long
	        };
	    }
	    // if a browser does not support navigator permission -> save coords to localStorage
	    if (type === 'userGeolocation' && !navigator.permissions && lat && long) {
	        var coords = {
	            lat: lat,
	            lng: long,
	            isDefaultCenterLocation: false
	        };
	        localStorage.setItem(lastAvailableGeolocationKey, JSON.stringify(coords));
	    }
	}

	/**
	 * @description get the user position, if available
	 * @param {boolean} isGeolocationSearch - true if user's address needs to be retrieved, false only for geolocation position
	 * @return {Object.lat} the user's latitude if available
	 * @return {Object.long} the user's longitude if available
	 */
	function getUserPosition(isGeolocationSearch) {
	    var result = {
	        lat: null,
	        long: null
	    };
	    if (isGeolocationSearch && userPositionData.userAddress) {
	        result.lat = userPositionData.userAddress.lat;
	        result.long = userPositionData.userAddress.long;
	    }
	    if (userPositionData.userGeolocation) {
	        result.lat = userPositionData.userGeolocation.lat;
	        result.long = userPositionData.userGeolocation.long;
	    }
	    return result;
	}

	module.exports = {
	    setUserPosition: setUserPosition,
	    getUserPosition: getUserPosition,
	    getUserPositionIfAvailable: getUserPositionIfAvailable
	};

/***/ }),

/***/ 192:
/***/ (function(module, exports, __webpack_require__) {

	/* globals google */
	'use strict';

	var storelocatorTemplateHelper = __webpack_require__(93),
	    userPositionHelper = __webpack_require__(94);

	var autocomplete = void 0;
	var markers = [];
	var map,
	    markerCluster,
	    numberStoreToShow,
	    storePins = [];

	var COUNTRY_RADIUS = 500;
	var CITY_RADIUS = 50;

	/**
	 * delete all the markers actually loaded on map
	 */
	function deleteMarkers() {
	    for (var i = 0; i < markers.length; i++) {
	        markers[i].setMap(null);
	    }
	    markers = [];
	}

	var isFilterByStoreBrands = $('.map-canvas').data('storelogic') === 'brands';
	var isFilterByStoreTypes = $('.map-canvas').data('storelogic') === 'types';

	/**
	 * update all the card and marker of Stores actually loaded on page
	 */
	function updateStores() {
	    var $storeButton = $('#button-map');
	    var $loadMoreStoresButton = $('#button-loadStores');
	    var mapCanvas = $('.map-canvas');
	    var mapdiv = storePins;
	    //Contains shop types if type logic is selected or shop brands if brand logic is selected
	    var storetypes = mapCanvas.data('storetypes');

	    // logic to control if there is at least one store type/brand selected in the checkbox group
	    var isAtLeastOneStoreTypeSelected = false;
	    for (var i = 0; i < storetypes.length; i++) {
	        if ($('#' + storetypes[i] + '-type').prop('checked')) {
	            isAtLeastOneStoreTypeSelected = true;
	            break;
	        }
	    }

	    var isAtLeastOneMarkerVisible = false;

	    if (markerCluster) {
	        markerCluster.clearMarkers();
	    }
	    if (markers.length > 0) {
	        deleteMarkers();
	    }
	    if ($storeButton.hasClass("active")) {
	        var infowindow = new google.maps.InfoWindow();
	        var bounds = new google.maps.LatLngBounds();

	        Object.keys(mapdiv).forEach(function (key) {
	            var item = mapdiv[key];
	            var storeLocation;
	            if (item.latitude && item.longitude) {
	                storeLocation = new google.maps.LatLng(item.latitude, item.longitude);
	            }
	            var marker;

	            // check if store has type selected in case of type logic
	            var isTypeSelected = isFilterByStoreTypes && $('#' + item.type + '-type').prop('checked');
	            // check if store has all selected brands in case of brand logic
	            var isBrandSelected = isFilterByStoreBrands && $('#' + item.storeBrand + '-type').prop('checked');

	            if (storeLocation && (isTypeSelected || isBrandSelected)) {
	                var markerImageKey = isBrandSelected ? item.storeBrand : item.type;
	                marker = new google.maps.Marker({
	                    position: storeLocation,
	                    title: item.name,
	                    icon: mapCanvas.data('markerimagepath')[markerImageKey]
	                });
	                marker.addListener('click', function () {
	                    infowindow.setOptions({
	                        content: item.infoWindowHtml
	                    });
	                    infowindow.open(map, marker);
	                });
	                // Create a minimum bound based on a set of storeLocations
	                bounds.extend(marker.position);
	                isAtLeastOneMarkerVisible = true;

	                markers.push(marker);
	            }
	        });

	        // if no store type selected go to default map center
	        // else center map based on found stores
	        if (!isAtLeastOneStoreTypeSelected || !isAtLeastOneMarkerVisible) {
	            var defaultLat = parseFloat(mapCanvas.attr('defaultlat'));
	            var defaultLong = parseFloat(mapCanvas.attr('defaultlong'));
	            map.setCenter({
	                lat: defaultLat,
	                lng: defaultLong
	            });
	        } else {
	            // eslint-disable-next-line no-undef
	            markerCluster = new MarkerClusterer(map, markers, {
	                imagePath: mapCanvas.attr('clusterimagepath'),
	                gridSize: 20
	            });
	            // Fit the all the store marks in the center of a minimum bounds when any store has been found.
	            if (mapdiv && mapdiv.length !== 0) {
	                map.fitBounds(bounds);
	            }
	        }
	    } else {
	        $('.cc-store-list-card').each(function () {
	            var child = $(this).find('.store-details')[0];
	            var type = $(child).attr('type');
	            var storeBrand = $(child).attr('storebrand');

	            // check if store has type selected in case of type logic
	            var isTypeSelected = isFilterByStoreTypes && $('#' + type + '-type').prop('checked');
	            // check if store has all selected brands in case of brand logic
	            var isBrandSelected = isFilterByStoreBrands && $('#' + storeBrand + '-type').prop('checked');

	            if (isTypeSelected || isBrandSelected) {
	                $(this).removeClass("d-none");
	            } else {
	                $(this).addClass("d-none");
	            }
	        });
	        //display 8 stores
	        numberStoreToShow = 8;
	        var numberStoresDisplayed = 0;
	        var isDisplayed = false;
	        $('.cc-store-list-card').each(function () {
	            isDisplayed = !$(this).hasClass("d-none");
	            if (isDisplayed) {
	                numberStoresDisplayed++;
	                if (numberStoresDisplayed <= 8) {
	                    $(this).removeClass("d-none");
	                } else {
	                    $(this).addClass("d-none");
	                }
	            }
	        });
	        if (!isAtLeastOneStoreTypeSelected || numberStoresDisplayed <= 8) {
	            $loadMoreStoresButton.addClass("d-none");
	        } else {
	            $loadMoreStoresButton.removeClass("d-none");
	        }
	    }
	}

	/**
	 * Render label under the query form
	*/
	function updateStoresResultsLabel(numberOfStores) {
	    var $result = $('.result-stores-number');
	    var $error = $('.result-stores-number-error');
	    var queryParam = $('#queryStoreParam')[0].value;
	    if (queryParam !== "") {
	        var displayMessage = String($result.data('message'));
	        displayMessage = displayMessage.replace("{0}", numberOfStores);
	        displayMessage = displayMessage.replace("{1}", "\"" + queryParam.toUpperCase() + "\"");
	        $result.removeClass('d-none');
	        $error.addClass('d-none');
	        $result.html(displayMessage);
	    } else {
	        $error.removeClass('d-none');
	        $result.addClass('d-none');
	    }
	}

	/**
	 * Render label under the query form in case of 0 stores were found by query
	 * @param {boolean} NeedToBeDisplayed - specify if the label needs to be displayed or not
	 */
	function showErrorLabel(NeedToBeDisplayed) {
	    var $queryError = $('#errorQuery');
	    var $errorLabel = $('.result-stores-number-error');
	    var queryParam = $('#queryStoreParam')[0].value;
	    if (NeedToBeDisplayed) {
	        $errorLabel.removeClass('d-none');
	        $queryError[0].textContent = queryParam;
	    } else {
	        $errorLabel.addClass('d-none');
	    }
	}

	/**
	 * Uses google maps api to render a map
	 */
	function maps() {
	    var mapCanvas = $('.map-canvas');
	    var defaultLat = mapCanvas.attr('defaultlat');
	    var defaultLong = mapCanvas.attr('defaultlong');
	    var defaultZoom = parseInt(mapCanvas.attr('defaultzoom'));

	    var latlng = new google.maps.LatLng(defaultLat, defaultLong);
	    var mapOptions = {
	        scrollwheel: false,
	        zoom: defaultZoom,
	        center: latlng,
	        zoomControl: true,
	        fullscreenControl: false,
	        streetViewControl: false,
	        mapTypeControl: false,
	        styles: [{
	            featureType: 'all',
	            elementType: 'all',
	            stylers: [{
	                saturation: -100
	            }]
	        }]
	    };

	    map = new google.maps.Map($('.map-canvas')[0], mapOptions);
	}

	/**
	 * Display 8 more stores
	 */
	function loadMoreStores() {
	    numberStoreToShow = numberStoreToShow + 8;
	    var numberStoresResult = 0;
	    var numberStoresDisplayed = 0;
	    var $loadMoreStoresButton = $('#button-loadStores');

	    $('.cc-store-list-card').each(function () {
	        var child = $(this).find('.store-details')[0];
	        var itemTypeValue = $(child).attr('type');
	        var storeBrand = $(child).attr('storebrand');

	        // check if store has type selected in case of type logic
	        var isTypeSelected = isFilterByStoreTypes && $('#' + itemTypeValue + '-type').prop('checked');
	        // check if store has all selected brands in case of brand logic
	        var isBrandSelected = isFilterByStoreBrands && $('#' + storeBrand + '-type').prop('checked');
	        var itShouldBeDisplayed = isTypeSelected || isBrandSelected;

	        if (itShouldBeDisplayed) {
	            numberStoresResult++;
	        }
	        //display the store only if it has a eligible brand or type (and the number of stores already displayed is < that the number expected)
	        if (numberStoresResult <= numberStoreToShow && itShouldBeDisplayed) {
	            $(this).removeClass("d-none");
	            numberStoresDisplayed++;
	        } else {
	            $(this).addClass("d-none");
	        }
	    });
	    if (numberStoresDisplayed === numberStoresResult) {
	        $loadMoreStoresButton.addClass("d-none");
	    } else {
	        $loadMoreStoresButton.removeClass("d-none");
	    }
	}

	/**
	 * Renders the results of the search and updates the map
	 * @param {Object} data - Response from the server
	 */
	function updateStoresResults(data) {
	    var $resultsDiv = $('.results');
	    var $mapDiv = $('.map-canvas');
	    var hasResults = data.stores.length > 0;
	    var storeResult = storelocatorTemplateHelper.showStoresResults(data, isFilterByStoreBrands);

	    //update the pins data
	    storePins = storeResult.pins;

	    $resultsDiv.empty().data('has-results', hasResults).data('radius', data.radius).data('search-key', data.searchKey);

	    //create the new store list
	    $resultsDiv.html(storeResult.storeList);

	    if ($mapDiv.data('has-google-api')) {
	        updateStores();
	    }
	}

	/**
	 * Renders the results of the search and updates the map without update the result label
	 * @param {string} lat - latitude to use in the query
	 * @param {string} long - longitude to use in the query
	 * @param {string} radius - optional, specify the radius to use in the query
	 */
	function initSearch(lat, long, radius) {
	    var $form = $('#queryStoreParam');
	    var url = $form.attr('action');
	    var userPosition = userPositionHelper.getUserPosition(true);
	    var payload = {
	        lat: lat,
	        long: long,
	        radius: radius,
	        userPositionLat: userPosition.lat,
	        userPositionLong: userPosition.long
	    };

	    $.ajax({
	        url: url,
	        type: $form.attr('method'),
	        data: payload,
	        dataType: 'json',
	        success: function success(data) {
	            updateStoresResults(data);
	            $('.result-stores-number').addClass('d-none');
	            showErrorLabel(false);
	        }
	    });
	}

	/**
	 * Makes the suggestion box visible only if the user has inserted at least 2 characters into the input field
	 */
	function noSuggestionBox() {
	    $('#queryStoreParam').on('input change focus keydown keyup', function (e) {
	        if ($('#queryStoreParam')[0].value.length < 2) {
	            //block the normal behavior every time except if the user has pressed the "enter" key
	            if (e.which !== 13 || e.type === 'keydown') {
	                //stop scrolling the previous results if the user press the arrows keys
	                if ($('.pac-item').length > 0 && (e.which === 40 || e.which === 38)) {
	                    e.preventDefault();
	                }
	                e.stopImmediatePropagation();
	            }
	            $('.pac-container').addClass('d-none');
	        } else {
	            var $googleSuggestion = $('.pac-container');
	            $googleSuggestion.removeClass('pac-logo');
	            $googleSuggestion.removeClass('d-none');
	        }
	    });
	}

	function defaultLandingSearch() {
	    var mapCanvas = $('.map-canvas');
	    var defaultLat = mapCanvas.attr('defaultlat'),
	        defaultLong = mapCanvas.attr('defaultlong'),
	        radius = mapCanvas.attr('defaultradius');
	    initSearch(defaultLat, defaultLong, radius);
	}

	/**
	 * Renders the results of the search and updates the map
	 * @param {string} lat - latitude to use in the query
	 * @param {string} long - longitude to use in the query
	 * @param {string} radius - optional, specify the radius to use in the query
	 */
	var getSuggestionUser = function getSuggestionUser(predictions) {
	    if (predictions) {
	        var geocoder = new google.maps.Geocoder();
	        geocoder.geocode({ placeId: predictions[0].place_id }, function (results) {
	            var lat = results[0].geometry.location.lat(),
	                long = results[0].geometry.location.lng();
	            userPositionHelper.setUserPosition(lat, long, 'userAddress');
	            var mapCanvas = $('.map-canvas');
	            var radius = mapCanvas.attr('defaultradius');
	            initSearch(lat, long, radius);
	        });
	    } else {
	        //no address suggestion available for user's address go with the default search
	        defaultLandingSearch();
	    }
	};

	/**
	 * Check if the user has an address, otherwise search all stores in the country
	 */
	function getOtherAddress() {
	    var userAddr = document.getElementById('user_addr').value;
	    if (userAddr !== "null") {
	        var service = new google.maps.places.AutocompleteService();
	        var geocodeRestriction = $('#queryStoreParam').attr('geocoderestriction');
	        service.getPlacePredictions({
	            input: userAddr,
	            componentRestrictions: {
	                country: geocodeRestriction
	            }
	        }, getSuggestionUser);
	    } else {
	        var mapCanvas = $('.map-canvas');
	        var lat = mapCanvas.attr('defaultlat'),
	            long = mapCanvas.attr('defaultlong'),
	            radius = mapCanvas.attr('defaultradius');
	        initSearch(lat, long, radius);

	        $('.welcomephrase').removeClass('d-none');
	    }
	}

	/**
	* Ask the user if he wants to use his position to execute a search in his proximity
	*/
	function geolocationInit() {
	    // Init listener on input field
	    noSuggestionBox();
	    if (navigator.geolocation) {
	        navigator.geolocation.getCurrentPosition(function (position) {
	            var lat = position.coords.latitude,
	                long = position.coords.longitude;
	            userPositionHelper.setUserPosition(lat, long, 'userGeolocation');
	            defaultLandingSearch();

	            map.setCenter({
	                lat: lat,
	                lng: long
	            });
	        }, getOtherAddress);
	    }
	}

	/**
	 * Renders the results of the search, updates the map and the results label
	 * @param {string} lat - latitude to use in the query
	 * @param {string} long - longitude to use in the query
	 * @param {string} radius - optional, specify the radius to use in the query
	 */
	function searchStore(lat, long, radius, options) {
	    $('.welcomephrase').addClass('d-none');
	    var $form = $('#queryStoreParam'),
	        defaultZoom = parseInt($('.map-canvas').attr('defaultzoom')),
	        url = $form.attr('action');

	    var userPosition = userPositionHelper.getUserPosition(options.isGeoLocationSearch);

	    // Determine appropriate zoom level based on radius
	    var zoom = defaultZoom;
	    if (radius) {
	        if (radius >= 500) {
	            zoom = 5; // Country level zoom
	        } else if (radius >= 50) {
	            zoom = 10; // Region/city level zoom
	        }
	    }

	    var payload = {
	        lat: lat,
	        long: long,
	        radius: radius,
	        userPositionLat: userPosition.lat || lat,
	        userPositionLong: userPosition.long || long
	    };

	    $.ajax({
	        url: url,
	        type: $form.attr('method'),
	        data: payload,
	        dataType: 'json',
	        success: function success(data) {
	            if ($('.js-storelocator-setcenter').data('storelocator-setcenter') === true) {
	                map.setCenter({
	                    lat: lat,
	                    lng: long
	                });
	                map.setZoom(zoom);

	                google.maps.event.addListenerOnce(map, 'idle', function () {
	                    updateStoresResults(data);
	                });
	            } else {
	                updateStoresResults(data);
	            }

	            if (data.hasNoResult) {
	                updateStoresResultsLabel(0);
	                showErrorLabel(true);
	            } else {
	                updateStoresResultsLabel(data.stores.length);
	                showErrorLabel(false);
	            }
	        }
	    });
	}

	/**
	 * Dafault search for storelocator
	*/
	function defaultSearch() {
	    var mapCanvas = $('.map-canvas');
	    var lat = mapCanvas.attr('defaultlat'),
	        long = mapCanvas.attr('defaultlong'),
	        radius = mapCanvas.attr('defaultradius');
	    searchStore(lat, long, radius, { isGeoLocationSearch: true });
	}

	function handlePlaceSearch(lat, long, results) {
	    var radius = false;

	    var isCountry = results.includes('country');
	    var isCity = results.includes('locality') || results.includes('administrative_area_level_1') || results.includes('administrative_area_level_2');

	    if (isCountry) {
	        radius = COUNTRY_RADIUS;
	    } else if (isCity) {
	        radius = CITY_RADIUS;
	    }

	    searchStore(lat, long, radius, {});
	}

	/**
	 * Get coordinates from the suggestion of google and execute a search
	 */
	function fillInAddress() {
	    var place = autocomplete.getPlace();
	    if (place.geometry) {
	        var lat = place.geometry.location.lat();
	        var long = place.geometry.location.lng();

	        var resultTypes = place.types || [];

	        handlePlaceSearch(lat, long, resultTypes);
	    }
	}

	/**
	 * Renders the results of the search and updates the map
	 * @param {Object} predictions - the predictions from Google Maps service
	 */
	var getSuggestion = function getSuggestion(predictions) {
	    if (predictions) {
	        var geocoder = new google.maps.Geocoder();
	        geocoder.geocode({ placeId: predictions[0].place_id }, function (results) {
	            var lat = results[0].geometry.location.lat(),
	                long = results[0].geometry.location.lng();

	            var resultTypes = results[0].types || [];

	            handlePlaceSearch(lat, long, resultTypes);
	        });
	    } else {
	        //no suggestion available for the query param, search stores by default lat and long, then show error messages
	        var mapCanvas = $('.map-canvas');
	        var lat = mapCanvas.attr('defaultlat'),
	            long = mapCanvas.attr('defaultlong'),
	            radius = mapCanvas.attr('defaultradius');
	        searchStore(lat, long, radius, { isGeoLocationSearch: true });
	    }
	};

	function changeMapVisualization() {

	    var $storeButton = $('#button-map');
	    var $listButton = $('#button-list');
	    var $storeList = $('#storeList');
	    var $storeMap = $('#storeMap');
	    var $loadMoreStoresButton = $('#button-loadStores');

	    $listButton.removeClass("active");
	    $storeButton.addClass("active");
	    $storeList.addClass("d-none");
	    $storeMap.removeClass("d-none");
	    $loadMoreStoresButton.addClass("d-none");

	    updateStores();
	}

	function changeListVisualization() {

	    var $storeButton = $('#button-map');
	    var $listButton = $('#button-list');
	    var $storeList = $('#storeList');
	    var $storeMap = $('#storeMap');
	    var $loadMoreStoresButton = $('#button-loadStores');

	    $storeButton.removeClass("active");
	    $listButton.addClass("active");
	    $storeMap.addClass("d-none");
	    $storeList.removeClass("d-none");
	    $loadMoreStoresButton.removeClass("d-none");

	    updateStores();
	}

	module.exports = {
	    init: function init() {
	        geolocationInit();
	        if ($('.map-canvas').data('has-google-api')) {
	            maps();
	        }
	        if (!$('.results').data('has-results')) {
	            $('.store-locator-no-results').show();
	        }
	    },

	    updateStoreType: function updateStoreType() {
	        $('body').on('change', '.checkboxTypeStore', function () {
	            updateStores();
	        });
	    },

	    initAutocomplete: function initAutocomplete() {
	        $(document).ready(function () {
	            var geocodeRestriction = $('#queryStoreParam').attr('geocoderestriction');
	            var placeTypes = $('#queryStoreParam').attr('data-place-types');
	            autocomplete = new google.maps.places.Autocomplete(document.getElementById('queryStoreParam'), {
	                types: placeTypes !== "" ? placeTypes.split(',') : [],
	                componentRestrictions: {
	                    country: geocodeRestriction
	                }
	            });
	            autocomplete.addListener("place_changed", fillInAddress);
	        });
	    },

	    watchMap: function watchMap() {
	        $('#button-map').click(function () {
	            changeMapVisualization();
	        });
	    },

	    watchList: function watchList() {
	        $('#button-list').click(function () {
	            changeListVisualization();
	        });
	    },

	    loadMoreStoresButton: function loadMoreStoresButton() {
	        $('#button-loadStores').click(function () {
	            loadMoreStores();
	        });
	    },

	    geolocalizationButton: function geolocalizationButton() {
	        $('#storeLocationButton').click(function () {
	            defaultLandingSearch();
	        });
	    },

	    searchButton: function searchButton() {
	        $('#searchStore').click(function () {
	            var queryParam = $('#queryStoreParam')[0].value;
	            if (queryParam !== "") {
	                var geocodeRestriction = $('#queryStoreParam').attr('geocoderestriction');
	                var placeTypes = $('#queryStoreParam').attr('data-place-types');
	                var service = new google.maps.places.AutocompleteService();
	                var options = {
	                    input: queryParam,
	                    types: placeTypes !== "" ? placeTypes.split(',') : [],
	                    componentRestrictions: {
	                        country: geocodeRestriction
	                    }
	                };
	                service.getPlacePredictions(options, getSuggestion);
	                $('.welcomephrase').addClass('d-none');
	                $('.result-stores-number').removeClass('d-none');
	            } else {
	                defaultSearch();
	                $('.welcomephrase').removeClass('d-none');
	                $('.result-stores-number').addClass('d-none');
	            }
	        });
	    },

	    enterKey: function enterKey() {
	        $('#queryStoreParam').keyup(function (e) {
	            //which = 13 -> enter key pressed
	            if (e.which === 13) {
	                $('#searchStore').trigger('click');
	            }
	        });
	    }
	};

/***/ })

/******/ });